import { render, staticRenderFns } from "./BaseBackToPreviousButton.vue?vue&type=template&id=3ac5cf8f&"
import script from "./BaseBackToPreviousButton.vue?vue&type=script&lang=js&"
export * from "./BaseBackToPreviousButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports